import * as Edge from "./Edges";

export const edgeTypes = {
  condition: Edge.Condition,
};
